var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUncxLogoSoloBrandLogo43E2F4Cd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UNCX_Network",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 289.56 214.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 289.56,
    y1: 107.14,
    x2: 0,
    y2: 107.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c68d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f847"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 140.28,
    y1: 71.04,
    x2: 136.46,
    y2: 92.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 147.71,
    y1: 156.46,
    x2: 221.33,
    y2: 129.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "triangle",
    className: "cls-4",
    d: "m253.39,0H36.17C6.27,0-10.67,34.27,7.49,58.03l108.61,142.08c12.31,16.1,34.78,18.49,50.1,7.15,2.67-1.95,5.11-4.34,7.26-7.15l45.1-67.44,63.51-74.65c18.16-23.75,1.22-58.03-28.68-58.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "head",
    className: "cls-2",
    d: "m262.41,63.53c1.69-3.39,7.64-9.88,4.19-12.45-8.24-6.15-20.65-10.72-34.78-8.47,1.47-3.37,8.55-10.25,3.8-12.86-9.1-5-24.36-10.77-38.23-3.55l-1.62-18.85c-.13-1.35-1.66-2.04-2.74-1.24l-21.69,16.03h0l-5.75-10.44c-.65-1.21-2.36-1.21-3.02,0l-7.3,13.29c-7.66,2.47-14.66,6.74-20.66,13.18L64.6,10.75c-1.76-.69-3.05,1.69-1.53,2.78,18.91,13.61,57.3,41.23,57.61,41.47,0,.01-39.18,61.75-39.18,61.76-6.04,9.66-2.8,17.87,7.28,23.11,5.69,2.94,12.08,4.02,18.37,3.37,8.85-.91,26.38-4.07,53.21-12.99h.01c.49-.14,12.54-3.46,19.31-12.23.03-.08.1-.14.14-.24,2.78-3.99,5.41-16.34-.04-28.35-.73-1.57.93-3.23,2.53-2.47,8.19,3.93,24.37,13.48,34.33,31.46.63,1.15,3.93,8.5,6.55,16.65h0s55.25-72.26,55.25-72.26c0,0,0,0,0,0-4.87-2.97-10.34-1.23-16.03.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye",
    className: "cls-1",
    d: "m126.52,90.2l20.12-18.04s6.27,8.58-1.71,16.01c0,0-7.98,7.08-18.4,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "neck",
    className: "cls-3",
    d: "m223.19,135.06l-49.73,65.05c-2.15,2.81-4.59,5.2-7.26,7.15,5.35-23.98,5.53-57.69-5.84-77.02h.01c.49-.14,12.54-3.46,19.31-12.23.03-.08.1-.14.14-.24,2.78-3.99,5.41-16.34-.04-28.35-.73-1.57.93-3.23,2.53-2.47,8.19,3.93,24.37,13.48,34.33,31.46.63,1.15,3.93,8.5,6.55,16.65Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncxLogoSoloBrandLogo43E2F4Cd);
export default __webpack_public_path__ + "static/media/uncx-logo-solo-brand-logo.43e2f4cd.0334f0c88f1099dc53a28a46ae29d4a9.svg";
export { ForwardRef as ReactComponent };